import { ApiResponse, TokenData, IInvoiceCancellationReason } from '../models';
import * as http from './http';
import ApiService from './service';

export class InvoiceCancellationReasonService extends ApiService {
  public async loadAllInvoiceCancellationReasons(): Promise<
    IInvoiceCancellationReason[]
  > {
    const url = `${this.apiDomain}/api/invoice-cancellation-reason`;

    const resposne = await http.get<ApiResponse<IInvoiceCancellationReason[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async updateInvoiceCancellationReason(
    data: IInvoiceCancellationReason,
    id?: string
  ) {
    const url = `${this.apiDomain}/api/invoice-cancellation-reason/${id}`;

    const response = await http.put<ApiResponse<IInvoiceCancellationReason>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async createInvoiceCancellationReason(
    data: IInvoiceCancellationReason
  ) {
    const url = `${this.apiDomain}/api/invoice-cancellation-reason`;

    const response = await http.post<ApiResponse<IInvoiceCancellationReason>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteInvoiceCancellationReason(id?: string) {
    const url = `${this.apiDomain}/api/invoice-cancellation-reason/${id}`;

    const response = await http.remove<ApiResponse<IInvoiceCancellationReason>>(
      url,
      this.store
    );
    return response.data;
  }
}
